import { Link } from 'react-router-dom'
import Seo, { SITE_URL } from '@/components/Seo'

function About() {
  return (
    <>
      <Seo
        title="About Dormer Calculator | Free Dormer Planning Tools"
        description="Dormer Calculator is a free planning tool and knowledge hub that helps homeowners and builders estimate dormer size, materials and cost."
        path="/about"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Dormer Calculator',
          url: SITE_URL,
          description: 'Free dormer calculator and guides for homeowners, builders and designers.',
        }}
      />
      <div className="border-b border-steel-200 bg-white">
        <div className="container-page py-10">
          <p className="eyebrow">About us</p>
          <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl">Clear numbers for dormer projects</h1>
        </div>
      </div>
      <div className="container-page py-10">
        <div className="mx-auto max-w-3xl space-y-5 text-lg">
          <p>
            Dormer Calculator exists for one reason: planning a dormer should not start with guesswork. Whether you are a homeowner weighing up a loft conversion or a builder preparing a quick budget, you deserve fast, honest numbers.
          </p>
          <h2 className="pt-4 text-2xl">What we do</h2>
          <p>
            We build a free <Link to="/calculator" className="font-semibold underline">dormer calculator</Link> that turns width, depth, height, roof pitch and material into roof area, a materials list and a cost range. Every formula is published on the calculator page so you can check the work.
          </p>
          <p>
            Alongside the tool, our <Link to="/blog" className="font-semibold underline">blog</Link> explains costs, planning permission, roof geometry, insulation and design choices in plain language.
          </p>
          <h2 className="pt-4 text-2xl">Our principles</h2>
          <ul className="list-disc space-y-2 pl-6">
            <li><strong>Transparent:</strong> formulas and assumptions are visible.</li>
            <li><strong>Practical:</strong> results you can hand to a contractor.</li>
            <li><strong>Honest about limits:</strong> estimates are not quotes, and we say so clearly.</li>
            <li><strong>Accessible:</strong> fast, keyboard friendly and readable on any device.</li>
            <li><strong>Independent:</strong> we do not sell leads or recommend specific contractors.</li>
          </ul>
          <h2 className="pt-4 text-2xl">How we keep the site free</h2>
          <p>
            The site is supported by clearly labeled advertising. Ads never change calculator results or editorial content.
          </p>
        </div>
      </div>
    </>
  )
}

export default About
